import type { ContentStatus } from "sj-ui-toolkit/src/atlas/components/ContentCard/contentCardTypes";
import type { Enrollment } from "sj-ui-toolkit/src/api/userEnrollments";
import type { QuestLevel } from "sj-ui-toolkit/src/atlas/contexts/Level/LevelContextProvider";

import { sortByEnrollment } from "./sortByEnrollment";

// The minimal data a learnin card (PathCard) renders — level paths and quests both
// satisfy it. Shared by LearninGrid and the dashboard bucket rows.
export interface Learnin {
  id: number | string;
  name: string;
  description: string;
  status?: ContentStatus;
  enrolled?: boolean;
}

// Role ids the user is enrolled in, for enrolled-first ordering (see sortByEnrollment).
export const getEnrolledRoleIds = (enrollments: Enrollment[] | null | undefined): Set<number> =>
  new Set((enrollments ?? []).filter(e => e.roleId != null).map(e => e.roleId));

// A quest's card links to its underlying path: the last path's id, falling back to the
// legacy response's role id. Quests without either are dropped.
const getQuestPathId = (quest: QuestLevel) => quest.paths?.slice(-1)[0]?.id ?? quest.role?.id;

// Normalize quests to card items, enrolled first.
export const questsToLearnins = (
  quests: QuestLevel[] | null | undefined,
  enrolledRoleIds: Set<number>
): Learnin[] => {
  const items = (quests ?? []).flatMap(quest => {
    const questPathId = getQuestPathId(quest);
    if (questPathId == null) return [];
    return [
      {
        id: questPathId,
        name: quest.name,
        description: quest.description,
        status: quest.status,
      },
    ];
  });
  return sortByEnrollment(items, enrolledRoleIds) ?? [];
};
